export default {
	dateRange: {
		ALL: 'All time',
		heading: 'Date range',
		LAST_7_DAYS: 'Last 7 days',
		LAST_30_DAYS: 'Last 30 days',
		TODAY: 'Today',
		YESTERDAY: 'Yesterday',
	},
	deliveredToggle: {
		heading: 'Hide delivered vehicles',
	},
	download: 'Download',
	search: 'Search in',
	status: {
		aria: 'Filter results by {status} status',
		chips: {
			allStatus: 'All',
			awaitingConfirmation: 'Awaiting confirmation',
			checksComplete: 'Checks complete',
			deliveryRequested: 'Delivery requested',
			reviewingDocs: 'Reviewing docs',
		},
		select: {
			allStatus: 'All statuses',
			awaitingConfirmation: 'Awaiting confirmation',
			checksComplete: 'Checks complete',
			deliveryRequested: 'Delivery requested',
			reviewingDocs: 'Reviewing documents',
		},
	},
};
